export default {
  input: document.querySelector('input'),
  galleryList: document.querySelector('.gallery'),
  body: document.querySelector('body'),

  form: document.getElementById('search-form'),
  loadMore: document.querySelector('.loadMore'),
};
